import { AutoMap } from "@automapper/classes";

export class PrelevementGenerateurDialyseEntity {

    Id?: number;
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Localisation!: number;
    @AutoMap()
    Bicarbonate?: number
    @AutoMap()
    Sodium?: number
    @AutoMap()
    AutreLocalisation?: string;
    @AutoMap()
    Observations!: string;
    @AutoMap()
    ModeDesinfection!: number;
    PrelevementId?: number;
}